import { useEffect } from 'react';

export default function useGlobalLazyImages(heroSelector = '#home img') {
  useEffect(() => {
    const inHero = new Set(Array.from(document.querySelectorAll(heroSelector)));
    document.querySelectorAll('img:not([loading])').forEach((img) => {
      if (inHero.has(img)) return; // keep above-the-fold eager
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    });
  }, [heroSelector]);
}
